require('./brokerWarrantsBuyView.scss');

const PropTypes = require('prop-types');

// @ vendors
const React = require('react');
const { connect } = require('react-redux');
const { withRouter } = require('react-router-dom');
const trim = require('lodash/string/trim');

// @ helpers
const { FormattedText, formatText } = require('core/i18n').i18n;

// @ commons
const Wizard = require('components/commons/wizard/wizard');
const WizardStep = require('components/commons/wizardStep/wizardStep');
const { OKCover } = require('commonsComponents/OKCover');
const { OKLink } = require('commonsComponents/OKLink');
const FormattedTextWithComponents = require('components/broker/brokerFormattedTextWithComponents/brokerFormattedTextWithComponents');
const { OKButton } = require('components/commons/OKButton/OKButton');

// @ components BrokerWarrantsHeader
const { BrokerWarrantsHeader } = require('components/broker/brokerProductHeaders/brokerWarrantsHeader/brokerWarrantsHeader');
const {
    BrokerWarrantsBuyStep1
} = require('components/broker/brokerWarrantsBuy/brokerWarrantsBuyStep1/brokerWarrantsBuyStep1');
const BrokerWarrantsBuyStep2 = require('components/broker/brokerWarrantsBuy/brokerWarrantsBuyStep2/brokerWarrantsBuyStep2');
const BrokerWarrantsBuySuccess = require('components/broker/brokerWarrantsBuy/brokerWarrantsBuySuccess/brokerWarrantsBuySuccess');
const BrokerTruncatedBreadcrumb = require('components/broker/brokerTruncatedBreadcrumb/brokerTruncatedBreadcrumb');
const { BrokerMiFIDBehavior } = require('mifid/components/brokerMiFIDBehavior/brokerMiFIDBehavior');
const PassContainer = require('components/contactCenter/passContainer/passContainer');

// @ actions
const BrokerWarrantsBuyActions = require('actions/brokerWarrantsBuy');
const WarrantFileActions = require('actions/brokerGetWarrantFile.js');
const BrokerConvenienceMiFIDTestAction = require('mifid/actions/brokerConvenienceMiFIDTest');
const BrokerOpenTraderActions = require('actions/brokerOpenTrader');
const BrokerMyInvestmentsActions = require('actions/brokerMyInvestments');
const BlockedAccountsActions = require('actions/blockedAccounts');
const profileActions = require('actions/profile');

//@ContactCenter
const BrokerLegalConfirmation = require('components/contactCenter/brokerLegalConfirmation/brokerLegalConfirmation');
const WebappRender = require('components/conditionalRender/webappRender')
const SELECTED_VALUES = require('constants/contactCenter/brokerLegalConfirmationSelectedValues');
const BrokerGetProductFileActions = require('actions/brokerGetProductFile');

//@utilities
const PersonalDataHelper = require('utilities/personalDataHelper');
const { downloadAsFile, base64ToBlob } = require('utilities/APIRequestHelper');

// @ constants
const {
    HIRE_VALUES_CONTRACT_URL,
    FIRST_STEP,
    MYPROFILE_BROKER_URL,
    MYPROFILE_BROKER_EXPLORE_URL,
    WIZARD_FIRST_STEP,
    BROKER_CONVENIENCE_MIFID_TEST_WARRANTS_ID,
    BROKER_CONVENIENCE_MIFID_WARRANT,
    BROKER_CONVENIENCE_MIFID_WARRANT_BUY,
    CONTENT_TYPE_PDF,
    BROKER_MIFID_VERSION_2,
    BROKER_BUY_SCREEN,
    BROKER_INFO_SCREEN,
} = require('constants/index');
const { catalogue, analyticsId } = require('components/broker/brokerWarrantsBuy/analytics/brokerWarrantsBuy.tracking');

class BrokerWarrantsBuyView extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            displayWizard: !__CONTACT_CENTER__,
            selectedValue: SELECTED_VALUES.EMPTY
        };

        this.getProductDetails = this.getProductDetails.bind(this);
        this.handleDisplayWizard = this.handleDisplayWizard.bind(this);
        this.handleYesNoOptionChange = this.handleYesNoOptionChange.bind(this);
        this.handleDownloadDFIDocument = this.handleDownloadDFIDocument.bind(this);
        this.handleDisclaimerClick = this.handleDisclaimerClick.bind(this);
        this.buildDisplayWizardButton = this.buildDisplayWizardButton.bind(this);
        this.buildEmailConfirmationContent = this.buildEmailConfirmationContent.bind(this);
        this.onCancel = this.onCancel.bind(this);
        this.getCatalogueDetails = this.getCatalogueDetails.bind(this);
    }

    componentWillMount() {
        const { history, immStocksContracts } = this.props;
        this.getCatalogueDetails();
        if (immStocksContracts.isEmpty()) {
            history.push(HIRE_VALUES_CONTRACT_URL);
        }
    }

    componentDidMount() {
        this.getProductDetails();
        this.handleMifid(this.props);
        this.props.fetchMyInvestments();
        this.props.fetchOpenTraderLink();
    }

    componentWillReceiveProps(nextProps) {
        this.handleMifid(nextProps);
    }

    componentWillUnmount() {
        this.props.onResetWarrantProductFile();
        this.props.reset();
        this.props.resetBlockedAccounts();
    }

    handleDisclaimerClick() {
        const dataBlock = this.props.immBrokerWarrantsBuy.get('WarrantsTransactionCostBase64Data');
        const dataID = this.props.immBrokerWarrantsBuy.get('WarrantsTransactionCostObjectId');
        if (dataBlock && dataID) {
            const base64String = `data:${CONTENT_TYPE_PDF};base64,${dataBlock}`;
            downloadAsFile(base64ToBlob(base64String), CONTENT_TYPE_PDF, dataID);
        }
    }

    onCancel() {
        this.props.history.push(MYPROFILE_BROKER_URL);
    }

    getBreadcrumbData(productFile, isin, iso) {
        return [
            {
                text: formatText('breadcrumb-brokerInvestments'),
                url: MYPROFILE_BROKER_URL
            },
            {
                text: formatText('breadcrumb-brokerAdvancedSearch'),
                url: MYPROFILE_BROKER_EXPLORE_URL
            },
            {
                text: productFile.get('companyName'),
                url: `/myprofile/broker/warrantsProductFile/${isin}/${iso}`
            },
            {
                text: formatText('breadcrumb-brokerStocksBuy'),
                url: ''
            }
        ];
    }

    getProductDetails() {
        const {
            getWarrantDetails,
            immBrokerConvenienceMiFIDTest,
            match: {
                params: { isin, iso },
            },
        } = this.props;
        const screenType = immBrokerConvenienceMiFIDTest.get('resultDisplayed')
            ? BROKER_BUY_SCREEN
            : BROKER_INFO_SCREEN;
        getWarrantDetails(isin, iso, screenType);
    }

    getCatalogueDetails() {
        this.props.getWarrantCatalogueDetails(this.props.match.params.isin);
    }

    buildSuccessful() {
        const { immBrokerWarrantsBuy, immStocksContracts, productFile, match } = this.props;
        return (
            <div className="broker-warrants-buy-view__success col-lg-12">
                <BrokerWarrantsBuySuccess
                    productFile={productFile}
                    immBrokerWarrantsBuy={immBrokerWarrantsBuy}
                    immStocksContracts={immStocksContracts}
                    isin={match.params.isin}
                />
            </div>
        );
    }

    handleYesNoOptionChange(value) {
        this.setState({
            selectedValue: value
        });
    }

    handleDisplayWizard() {
        this.setState({
            displayWizard: true,
        })
    }

    handleDownloadDFIDocument() {
        this.props.onDownloadDFIDocument(this.props.match.params.isin, this.props.history);
    }

    buildLinkButton(label, handleClick) {
        return (
            <OKButton
                modifier="link-inline"
                onClick={handleClick}
            >
                <span className="ok-link">{label}</span>
            </OKButton>
        );
    }

    buildLinkOrLabel(link, label) {
        if (link) {
            return (
                <OKLink to={link} target="_blank">
                    {label}
                </OKLink>
            );
        }
        return label;
    }

    buildWarrantsBuyDocumentLink(translationKey, documentUrlKey, handleClick) {
        const { immBrokerWarrantsBuy } = this.props;
        const label = formatText(`warrantsBuy-${translationKey}`);
        if (handleClick) {
            return this.buildLinkButton(label, handleClick);
        }
        const link = immBrokerWarrantsBuy.get(documentUrlKey) || '';
        return this.buildLinkOrLabel(link, label);
    }

    buildLegalTextProductDescription() {
        const warrantName = this.props.productFile.get('companyName');

        return (
            <div>
                <p>{formatText("warrantsBuy-firstWarrantsBuyFeature", [warrantName])}</p>
            </div>
        )
    }

    buildLegalTextMandatoryReading() {
        const { immFeatureFlags } = this.props;
        if (immFeatureFlags.get('wealth_warrants_buy_show_costs')) {
            return null;
        }
        const costsAndAssociatedExpensesReportLabelLink = this.buildWarrantsBuyDocumentLink("costsAndAssociatedExpensesReportLabelLink",
            "", this.handleDisclaimerClick);
        return (
            <div>
                <FormattedTextWithComponents
                    value="warrantsBuy-legalTextMandatoryReading1"
                    injectedComponents={[costsAndAssociatedExpensesReportLabelLink]}
                />
                <ul>
                    <li>{formatText("warrantsBuy-legalTextMandatoryReading2")}</li>
                    <li>{formatText("warrantsBuy-legalTextMandatoryReading3")}</li>
                    <li>{formatText("warrantsBuy-legalTextMandatoryReading4")}</li>
                </ul>
            </div>
        );
    }

    buildLegalDisclaimerDocumentLinksSection() {
        const { immFeatureFlags } = this.props;
        const fundamentalDataForInvestorLink = this.buildWarrantsBuyDocumentLink("fundamentalDataForInvesorLabelLink", '', this.handleDownloadDFIDocument);
        const costsAndAssociatedExpensesReportLabelLink = this.buildWarrantsBuyDocumentLink("costsAndAssociatedExpensesReportLabelLinkAlternative",
            "", this.handleDisclaimerClick);
        const showExantCostBuyWarrants = immFeatureFlags.get(
            "wealth_warrants_buy_show_costs"
        );
        const linksKey = showExantCostBuyWarrants
            ? "warrantsBuy-legalDisclaimerDocumentsLinkText2WithoutCost"
            : "warrantsBuy-legalDisclaimerDocumentsLinkText2";
        const linksArray = showExantCostBuyWarrants
            ? [fundamentalDataForInvestorLink]
            : [
                fundamentalDataForInvestorLink,
                costsAndAssociatedExpensesReportLabelLink,
            ];
        return (
            <div>
                <p>{formatText("warrantsBuy-legalDisclaimerDocumentsLinkText1")}</p>
                <p>
                    <FormattedTextWithComponents
                        value={linksKey}
                        injectedComponents={linksArray}
                    />
                </p>
            </div>
        );
    }

    buildLegalDisclaimerAcceptanceText() {
        const { immProfileFields } = this.props;
        const clientName = PersonalDataHelper.getFullName(immProfileFields, false);

        return (
            <div>
                <p>{formatText("warrantsBuy-legalDisclaimerAcceptanceText1")}</p>
                <p>{formatText("warrantsBuy-legalDisclaimerAcceptanceText2", [clientName])}</p>
            </div>
        );
    }

    buildLegalDisclaimerProductDescription() {
        const { immProfileFields } = this.props;
        const clientName = PersonalDataHelper.getFullName(immProfileFields, false);
        const warrantName = this.props.productFile.get('companyName');

        return (
            <div>
                <p>{formatText("warrantsBuy-legalDisclaimerProductDescription1", [clientName])}</p>
                <ul>
                    <li>{formatText("warrantsBuy-legalDisclaimerProductDescription2", [warrantName])}</li>
                    <li>{formatText("warrantsBuy-legalDisclaimerProductDescription3")}</li>
                </ul>
            </div>
        );
    }

    buildDisplayWizardButton() {
        return (
            <div className="broker-warrants-buy-view__wizard-cc-button">
                <OKButton
                    onClick={this.handleDisplayWizard}
                    disabled={this.state.selectedValue !== SELECTED_VALUES.YES}
                    modifier="secondary"
                >
                    {formatText("warrantsBuy-displayWizardButtonText")}
                </OKButton>
            </div>
        );
    }

    buildEmailConfirmationContent() {
        const {
            immBrokerWarrantsBuy,
            sendLeaglConfirmationMail,
            resetLeaglConfirmationMail,
            requestProfile,
            immProfileFields
        } = this.props;

        let legalConfirmationContent;
        const visibleStep = immBrokerWarrantsBuy.get('visibleStep');

        const buildLegalDisclaimerYesAnswer = () => {
            return (
                <div>
                    <p>{formatText("warrantsBuy-legalDisclaimerYesAnswerStatement")}</p>
                </div>
            );
        };

        const buildLegalDisclaimerNoAnswer = () => {
            const legalDisclaimerNoAnswerFirstStatement = formatText("warrantsBuy-legalDisclaimerNoAnswerFirstStatement");
            const legalDisclaimerNoAnswerSecondStatement = formatText("warrantsBuy-legalDisclaimerNoAnswerSecondStatement");
            return (
                <div>
                    <p>{legalDisclaimerNoAnswerFirstStatement}</p>
                    <p>{legalDisclaimerNoAnswerSecondStatement}</p>
                </div>
            );
        };

        const buildBrokerLegalConfirmation = () => {
            const clientEmail = PersonalDataHelper.getEmail(immProfileFields);
            const refreshEmailError = immProfileFields.get('error');
            return (
                <BrokerLegalConfirmation
                    legalDisclaimerQuestion={this.buildLegalDisclaimerAcceptanceText()}
                    legalDisclaimerYesAnswer={buildLegalDisclaimerYesAnswer()}
                    legalDisclaimerNoAnswer={buildLegalDisclaimerNoAnswer()}
                    legalDisclaimerProductDescription={this.buildLegalDisclaimerProductDescription()}
                    legalDisclaimerDocumentLinks={this.buildLegalDisclaimerDocumentLinksSection()}
                    legalDisclaimerMandatoryReading={this.buildLegalTextMandatoryReading()}
                    onYesNoOptionChange={this.handleYesNoOptionChange}
                    selectedYesNoOption={this.state.selectedValue}
                    sendMail={sendLeaglConfirmationMail}
                    resetMailState={resetLeaglConfirmationMail}
                    clientEmailAddress={clientEmail}
                    refreshEmailAddress={requestProfile}
                    immPreContractualMail={immBrokerWarrantsBuy}
                    refreshEmailAddressError={refreshEmailError}
                    sendMailParams={{ clientEmail }}
                    className={"broker-warrants-buy-view__legal-confirmation"}
                />
            );
        }

        if (__CONTACT_CENTER__ && visibleStep == WIZARD_FIRST_STEP) {
            legalConfirmationContent = (
                <div className="broker-warrants-buy-view__wizard-cc" id="printable-wizard">
                    {buildBrokerLegalConfirmation()}
                    {this.buildDisplayWizardButton()}
                </div>
            )
        }
        return legalConfirmationContent;
    }

    buildInnerWizard() {
        const {
            setVisibleStep,
            setWillCancel,
            validateStep,
            immBrokerWarrantsBuy,
            immStocksContracts,
            productFile,
            finish,
            handleChangeReadChecked,
            handleChangeWarningOperationChecked,
            warrantTransactionCost,
            setDocumentsRead,
            immFeatureFlags,
            fetchExtantCostWarrantsBuy
        } = this.props;

        const productCurrency = productFile.get('currencyCode');
        const productPrice = productFile.get('buyPrice');
        const immSteps = immBrokerWarrantsBuy.get('steps');
        const visibleStep = immBrokerWarrantsBuy.get('visibleStep');
        const actions = {
            setVisibleStep,
            validateStep,
            cancel: this.onCancel,
            setWillCancel,
            finish
        };
        const fees_url = formatText('broker-product_buy_sale_flow_see_fees_link');
        const titleHeaderMenuWizard = visibleStep === 1 ? formatText('broker-warrantsBuyViewWizardTitle') : formatText('broker-warrantsBuyViewWizardTitleStepTwo');
        const headerMenuData = {
            title: titleHeaderMenuWizard,
            linksData: [
                /*{
                    label: formatText('broker-warrantsBuyViewWizardFirstLinkLabel'),
                    href: `/myprofile/broker/warrantsAdvancedBuy/${params.isin}/${params.iso}`,
                    hasTooltip: false
                },*/
                {
                    label: formatText('broker-warrantsBuyViewWizardSecondLinkLabel'),
                    href: fees_url,
                    hasTooltip: false,
                    target: '_blank'
                },
            ]
        };
        const isin = this.props.match.params.isin;
        const tealiumData = [
            catalogue[analyticsId.BROKER_WARRANTS_BUY_STEP_1_VIEW]({ productName: isin }),
            catalogue[analyticsId.BROKER_WARRANTS_BUY_STEP_2_VIEW]({ productName: isin }),
        ];
        const tealiumEvents = [
            catalogue[analyticsId.BROKER_WARRANTS_BUY_STEP_1_SUCCESS](),
        ];

        return (
            <Wizard
                wizardClass={'broker-warrants-buy-view__wizard'}
                actions={actions}
                immSteps={immSteps}
                stepsAmount={immSteps.size}
                visibleStep={visibleStep}
                hasHeaderMenu={true}
                headerMenuData={headerMenuData}
                tealium={tealiumData[visibleStep - 1]}
                tealiumEvents={{
                    next: tealiumEvents[visibleStep - 1],
                }}
                isTaggingSecondVersion
            >
                <WizardStep
                    position="first"
                    cancelButton={true}
                    isLoading={immSteps.getIn([FIRST_STEP, 'loading'])}
                >
                    <BrokerWarrantsBuyStep1
                        productCurrency={productCurrency}
                        productPrice={productPrice}
                        warrantTransactionCost={warrantTransactionCost}
                        fundIsin={isin}
                    />
                </WizardStep>
                <WizardStep
                    position="last"
                    immFinalButton="broker-warrantsBuyViewFinishButtonLabel"
                    cancelButton={true}
                >
                    <BrokerWarrantsBuyStep2
                        productFile={productFile}
                        immBrokerWarrantsBuy={immBrokerWarrantsBuy}
                        immStocksContracts={immStocksContracts}
                        handleChangeReadChecked={handleChangeReadChecked}
                        handleChangeWarningOperationChecked={handleChangeWarningOperationChecked}
                        validateCheck={this.props.validateCheck}
                        warrantTransactionCost={warrantTransactionCost}
                        fundIsin={isin}
                        onDownloadDFIDocument={this.props.onDownloadDFIDocument}
                        setDocumentsRead={setDocumentsRead}
                        immFeatureFlags={immFeatureFlags}
                        fetchExtantCostWarrantsBuy={fetchExtantCostWarrantsBuy}
                    />
                </WizardStep>
            </Wizard>
        );
    }

    buildWizard() {
        const emailConfirmationContent = this.buildEmailConfirmationContent();
        return __CONTACT_CENTER__ ? (
            <div>
                {emailConfirmationContent}
                <PassContainer disable={!this.state.displayWizard}>
                    {this.buildInnerWizard()}
                </PassContainer>
            </div>
        ) : this.buildInnerWizard()
    }

    handleMifid(/*props*/) {
        /*if (props.immStocksContracts.isEmpty()) {
            return;
        }

        const productName = (props.productFile.get('companyName') || '').trim();

        if (!productName) {
            return;
        }

        const isin = props.params.isin;
        const iso = props.params.iso;

        const productUrl = `/myprofile/broker/warrantsProductFile/${isin}/${iso}`;
        const productMifidId = BROKER_CONVENIENCE_MIFID_TEST_WARRANTS_ID;
        const continuationUrl = `/myprofile/broker/warrantsBuy/${isin}/${iso}`;

        props.onStartConvenienceMiFIDTest(
          productName,
          productUrl,
          productMifidId,
          continuationUrl,
          {
            productType: BROKER_CONVENIENCE_MIFID_WARRANT,
          }
        );*/
    }

    render() {
        const { immMyInvestments, immBrokerWarrantsBuy, immOpenTrader, productFile, warrantFile, match: { params } } = this.props;
        const mappingBreadcrumb = this.getBreadcrumbData(productFile, params.isin, params.iso);
        const productName = trim(this.props.productFile.get('companyName'));
        const isin = this.props.match.params.isin;
        const iso = this.props.match.params.iso;
        const productUrl = `/myprofile/broker/warrantsProductFile/${isin}/${iso}`;
        const continuationUrl = `/myprofile/broker/warrantsBuy/${isin}/${iso}`;
        const mifidOptions = {
            productType: BROKER_CONVENIENCE_MIFID_WARRANT,
            operationType: BROKER_CONVENIENCE_MIFID_WARRANT_BUY,
            hideAlreadyPerformTestResult: true,
        };

        let contractBoxContent;
        if (productFile.get('isFetched')) {
            if (immBrokerWarrantsBuy.get('submitSuccessful')) {
                contractBoxContent = this.buildSuccessful();
            } else {
                contractBoxContent = this.buildWizard();
            }
        }

        return (
            <BrokerMiFIDBehavior
                mifidVersion={BROKER_MIFID_VERSION_2}
                productName={productName}
                productUrl={productUrl}
                continuationUrl={continuationUrl}
                productIsinId={isin}
                productMarketId={iso}
                productMifidId={BROKER_CONVENIENCE_MIFID_TEST_WARRANTS_ID}
                mifidOptions={mifidOptions}
            >
                <div>
                    <div className="container-fluid">
                        <div className="row">
                            <OKCover size="medium" section="broker" customClass="col-xs-12">
                                <BrokerTruncatedBreadcrumb
                                    titleKey="broker-warrantsBuyViewTitle"
                                    breadcrumbConfig={mappingBreadcrumb}
                                    className="broker-warrants-buy-view__header">
                                    <OKButton inverse={true} modifier="ghost" to={MYPROFILE_BROKER_EXPLORE_URL}>
                                        <FormattedText format="firstUppercase" value="broker-goToAdvancedSearch" />
                                    </OKButton>
                                    <WebappRender>
                                        <OKButton inverse={true} modifier="primary" to={immOpenTrader.get('openTraderLink')}>
                                            <FormattedText format="firstUppercase" value="broker-openTraderLabel" />
                                        </OKButton>
                                    </WebappRender>
                                </BrokerTruncatedBreadcrumb>
                            </OKCover>
                        </div>
                    </div>
                    <div className="grid-view__body">
                        <div className="container-fluid">
                            <div className="row grid-view--content-position-negative">
                                <div className="col-xs-12">
                                    <BrokerWarrantsHeader
                                        productFile={productFile}
                                        warrantFile={warrantFile}
                                        immMyInvestments={immMyInvestments}
                                        handleUpdate={this.getProductDetails}
                                        exchangeId={this.props.match.params.exchangeId}
                                        spcSymbol={this.props.match.params.spcSymbol}
                                        noBottomButtons={true}
                                    />
                                    <div className="broker-warrants-buy-view__wizard">
                                        {contractBoxContent}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </BrokerMiFIDBehavior>
        );
    }
}

BrokerWarrantsBuyView.propTypes = {
    history: PropTypes.object.isRequired,
    productFile: PropTypes.object,
    immBrokerWarrantsBuy: PropTypes.object,
    immOpenTrader: PropTypes.object.isRequired,
    resetBlockedAccounts: PropTypes.func,
    immStocksContracts: PropTypes.object,
    immBrokerConvenienceMiFIDTest: PropTypes.object.isRequired,
    immVariables: PropTypes.object.isRequired,
    reset: PropTypes.func,
    setVisibleStep: PropTypes.func,
    setWillCancel: PropTypes.func,
    finish: PropTypes.func,
    validateStep: PropTypes.func,
    getWarrantDetails: PropTypes.func,
    match: PropTypes.object,
    onStartConvenienceMiFIDTest: PropTypes.func.isRequired,
    fetchOpenTraderLink: PropTypes.func.isRequired,
    handleChangeReadChecked: PropTypes.func.isRequired,
    handleChangeWarningOperationChecked: PropTypes.func.isRequired,
    validateCheck: PropTypes.func.isRequired,
    fetchMyInvestments: PropTypes.func.isRequired,
    warrantTransactionCost: PropTypes.func.isRequired,
    immProfileFields: PropTypes.object.isRequired,
    sendLeaglConfirmationMail: PropTypes.func.isRequired,
    resetLeaglConfirmationMail: PropTypes.func.isRequired,
    requestProfile: PropTypes.func.isRequired,
    immMyInvestments: PropTypes.object.isRequired,
    onDownloadDFIDocument: PropTypes.func.isRequired,
    onResetWarrantProductFile: PropTypes.func.isRequired,
    setDocumentsRead: PropTypes.func.isRequired,
    immFeatureFlags: PropTypes.object.isRequired,
    fetchExtantCostWarrantsBuy: PropTypes.func.isRequired,
    warrantFile: PropTypes.object,
};

module.exports.constructor = BrokerWarrantsBuyView;
module.exports.BrokerWarrantsBuyView = connect(
    state => ({
        productFile: state.brokerProductFile,
        immBrokerWarrantsBuy: state.brokerWarrantsBuy,
        immOpenTrader: state.brokerOpenTrader,
        immStocksContracts: state.brokerStocksContract,
        immProfileFields: state.profile,
        immMyInvestments: state.brokerMyInvestments,
        immVariables: state.globalVariables,
        immFeatureFlags: state.flagBasedFeatures,
        immBrokerConvenienceMiFIDTest: state.brokerConvenienceMiFIDTest,
        warrantFile: state.brokerWarrantsFile,
    }),
    {
        reset: BrokerWarrantsBuyActions.reset,
        resetBlockedAccounts: BlockedAccountsActions.resetBlockedAccounts,
        setVisibleStep: BrokerWarrantsBuyActions.setVisibleStep,
        setWillCancel: BrokerWarrantsBuyActions.setWillCancel,
        validateStep: BrokerWarrantsBuyActions.validateStep,
        getWarrantCatalogueDetails: WarrantFileActions.getWarrantCatalogueDetails,
        getWarrantDetails: WarrantFileActions.getWarrantFile,
        finish: BrokerWarrantsBuyActions.finish,
        onStartConvenienceMiFIDTest: BrokerConvenienceMiFIDTestAction.start,
        fetchOpenTraderLink: BrokerOpenTraderActions.fetchLink,
        handleChangeReadChecked: BrokerWarrantsBuyActions.changeReadChecked,
        handleChangeWarningOperationChecked: BrokerWarrantsBuyActions.changeWarningOperationChecked,
        validateCheck: BrokerWarrantsBuyActions.validateCheck,
        fetchMyInvestments: BrokerMyInvestmentsActions.fetchMyInvestments,
        warrantTransactionCost: BrokerWarrantsBuyActions.fetchWarrantTransactionCost,
        sendLeaglConfirmationMail: BrokerWarrantsBuyActions.sendLeaglConfirmationMail,
        resetLeaglConfirmationMail: BrokerWarrantsBuyActions.resetLeaglConfirmationMail,
        requestProfile: profileActions.requestProfile,
        onDownloadDFIDocument: BrokerWarrantsBuyActions.downloadDFIDocument,
        onResetWarrantProductFile: BrokerGetProductFileActions.reset,
        setDocumentsRead: BrokerWarrantsBuyActions.setDocumentsRead,
        fetchExtantCostWarrantsBuy: BrokerWarrantsBuyActions.getExtantCostBuyWarrant
    }
)(withRouter(BrokerWarrantsBuyView));
